import { cn } from '@/utils';

interface TrackButtonProps {
  direction: 'increase' | 'decrease';
  onClick: (e: React.MouseEvent) => void;
  size?: number;
}

const TrackButton: React.FC<TrackButtonProps> = ({ direction, onClick, size = 8 }) => {
  const isDecrease = direction === 'decrease';

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick(e);
      }}
      className={`h-full cursor-pointer flex items-center justify-center group/${direction} relative`}
    >
      <div className="absolute inset-0 -mx-4" />
      <div
        className={cn(
          'w-0 h-0 border-y-transparent transition-opacity duration-200 relative z-10',
          `group-hover/${direction}:opacity-100 opacity-30`,
        )}
        style={{
          borderTopWidth: `${Math.floor(size * 0.375)}px`,
          borderBottomWidth: `${Math.floor(size * 0.375)}px`,
          ...(isDecrease
            ? { borderRightWidth: `${Math.floor(size * 0.625)}px`, borderRightColor: '#EBEEEE' }
            : { borderLeftWidth: `${Math.floor(size * 0.625)}px`, borderLeftColor: '#EBEEEE' }),
        }}
      />
    </div>
  );
};

export default TrackButton;
